import { forwardRef, useEffect, useImperativeHandle, useRef, useState, useCallback } from 'react'
import { SAlert, SDrawerOrModal, SGeneralForms, STitle } from 'shj-components'
import styles from '../../../index.module.less'
import { Button, Col, Input, Row, Select, Form, Spin, message } from 'antd'
import FormModal from './formModal'
import {
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons'
import _, { isEmpty } from 'lodash'
import SkuTable from './SkuTable'
import {
  getArgPage,
  createSkuByArgs,
  getOrCacheArgManageShortcut,
  getOrCacheProductRuleDtl,
  getArgList,
  deleteCacheProductRuleDtl,
  saveCacheArgManageShortcut,
} from '@/services/product'
import { useSetState } from 'ahooks'
import { useParams } from 'react-router-dom'
import { useStore, useAtomValue, useAtom } from 'jotai'
import { useResetAtom } from 'jotai/utils'
import { step1DataAtom, step2DataAtom } from '../store'

export default forwardRef(function Step2(
  {
    paramList = [],
    filterParamList = [],
    setFilterParamList = () => ({}),
    showCreateFlag = false,
    setShowCreateFlag = () => ({}),
  }: any,
  ref
) {
  const { id } = useParams() // 产品id
  const [formRef] = Form.useForm() // 规格参数表单
  const [unFormRef] = Form.useForm() // 非规格参数表单
  const createSkuFormRef = useRef<any>(null) //创建sku表单
  const [skuFormOpen, setSkuFormOpen] = useState(false)
  const [oldPackValue, setOldPackValue] = useState<any>('') // 处理打包模板变化后的值
  const [openSpecsModal, setOpenSpecsModal] = useState(false)
  const [chooseModalType, setChooseModalTyep] = useState('')
  const [spinLoading, setSpinLoading] = useState(false)
  const step1Data = useAtomValue(step1DataAtom)
  const [step2Data, setStep2Data] = useAtom(step2DataAtom)
  const reset = useResetAtom(step2DataAtom)

  const onCreateSkuFormRef = () => {
    return createSkuFormRef.current?.onFormRef()
  }

  // 这里差了回显逻辑，到时候统一补上应该
  useEffect(() => {
    if (!step1Data.packModelId && step1Data.packModelId !== oldPackValue) {
      reset()
      formRef.resetFields()
      unFormRef.resetFields()
    }
    setOldPackValue(step1Data.packModelId)
  }, [step1Data.packModelId])

  useEffect(() => {
    // 监听表单更改参数列表 去重
    const list = [
      ...(step2Data.config[0]?.formItem || []),
      ...(step2Data.notStandardConfig[0]?.formItem || []),
    ]
    const newParamList: any = [...paramList]
    const array: any = []
    newParamList.forEach((item, index) => {
      if (list.findIndex(el => el.name === item.argCode) === -1) {
        array.push(item)
      }
    })
    setFilterParamList([...array])
  }, [step2Data.config, step2Data.notStandardConfig])

  useEffect(() => {
    // 弹窗表单赋值
    const formValue = formRef.getFieldsValue()
    if (skuFormOpen && formValue) {
      onCreateSkuFormRef().setFieldsValue({
        ...formValue,
      })
    }
  }, [skuFormOpen])

  useImperativeHandle(
    ref,
    () => {
      return {
        onSubmit,
        step2FormRef: formRef,
        step2UnFormRef: unFormRef,
      }
    },
    [step2Data, step1Data]
  )

  // 动态添加参数表单
  const onConfirm = async (value: Array<any>, list: Array<any>) => {
    const renderList = list.filter(el => value.includes(el.argCode))

    const isSpec = chooseModalType === 'standard' ? true : false
    // 去生成表单
    const newConfig = dataToForm(renderList, isSpec)

    if (chooseModalType === 'standard') {
      setStep2Data({ ...step2Data, config: [...newConfig], skuList: [], skuTableColumns: [] })
    } else {
      setStep2Data({ ...step2Data, notStandardConfig: [...newConfig] })
    }

    setOpenSpecsModal(false)
  }
  // 移除参数
  const remove = (filed: any, type: string) => {
    const newConfig = type === 'standard' ? [...step2Data.config] : [...step2Data.notStandardConfig]
    // const index = newConfig[0].formItem.findIndex(item => item.name === filed)
    // newConfig[0].formItem.splice(index, 1)
    newConfig[0].formItem = newConfig[0].formItem?.filter(item => item.name !== filed)
    if (type === 'standard') {
      setStep2Data({
        ...step2Data,
        config: [...newConfig],
        skuList: [],
        skuTableColumns: [],
        skuByArgs: [],
      })
    } else {
      setStep2Data({
        ...step2Data,
        notStandardConfig: _.cloneDeep(newConfig),
      })
    }
  }
  // 删除sku信息
  const deleteSkuData = () => {
    if (['PRODUCT_PACKAGE', 'PRODUCT_DETAILS'].includes(step1Data.prodType)) return
    setStep2Data({
      ...step2Data,
      skuList: [],
      skuTableColumns: [],
      skuByArgs: [],
    })
  }
  // 添加参数
  const clickToAdd = type => {
    setChooseModalTyep(type)
    setOpenSpecsModal(true)
  }
  // 参换转表单渲染
  const dataToForm = (list, isSpec = true, type?: string) => {
    let newConfig =
      type === 'reset'
        ? []
        : chooseModalType === 'standard'
        ? [...step2Data.config]
        : [...step2Data.notStandardConfig]

    if (!newConfig[0]?.formItem) {
      newConfig[0] = {
        formItem: [],
      }
    }
    list.forEach(item => {
      const isPackage = ['PRODUCT_PACKAGE', 'PRODUCT_DETAILS'].includes(step1Data.prodType)
      // 打包模板数据限制
      if (isPackage) {
        if (isSpec) {
          // 默认的数据不可编辑删除
          item.forBidDelete = true
          // 带出规格参数的值
          formRef.setFieldValue(
            item.argCode,
            item.values?.length ? [...item.values?.map(item => item.valueId)] : undefined
          )
        } else {
          // 新增的数据能删除编辑
          item.forBidDelete = false
          // 带出非规格参数的值
          unFormRef.setFieldValue(
            item.argCode,
            item.values?.length ? [...item.values?.map(item => item.valueId)] : undefined
          )
        }
      }

      const current = paramList.find(arg => arg.argCode === item.argCode) || {}

      newConfig[0].formItem.push({
        ...item,
        label: item.argName,
        name: item.argCode,
        spanCol: 24,
        required: item.argType === 'CHOOSE' ? true : false,
        options: current,
        type: item.argType,
      })
    })

    return newConfig
  }
  // 确认将规格参数生成SKUtable
  const onModalSubmit = data => {
    const value = onCreateSkuFormRef().getFieldsValue()
    if (isEmpty(value)) return
    clickToSkuTable(value)
  }

  // 数据转table
  const clickToSkuTable = async (resData?) => {
    const jsonList = dataHandle(resData)
    createSkuByArgs({
      spuName: step1Data.prodName,
      argList: jsonList,
    }).then(res => {
      const { column, data } = argListToTable(res)
      setStep2Data({
        ...step2Data,
        skuList: data,
        skuTableColumns: column,
        argsJsonList: jsonList,
        skuByArgs: res?.skuList,
      })
      setSkuFormOpen(false)
    })
  }
  // 参数转表格数据
  const argListToTable = res => {
    const { argList, skuList: list } = res
    const column: any = []
    const data: any = []
    // 1.获取表头
    if (argList?.length > 0) {
      argList?.forEach(item => {
        column.push({
          dataIndex: item.argCode,
          title: item.argName,
        })
      })

      // 2.转化数据
      list.forEach(item => {
        const obj: any = {
          ...item,
        }
        Object.keys(item?.argMap)?.forEach(arg => {
          obj[arg] = item?.argMap?.[arg]?.valueName
        })
        data.push(obj)
      })
    } else {
      // 无参数 只存在sku
      console.log(list, 'list')
      data.push({
        id: list[0].id,
      })
    }

    return {
      column: column,
      data: data,
    }
  }
  // 添加配置，勾选参数
  const openToCreate = () => {
    setSkuFormOpen(true)
  }
  // 添加配置前，数据处理
  const dataHandle = (resData?) => {
    // 表单值
    let formData
    const standardObj = formRef.getFieldsValue()
    const unStandardObj = unFormRef.getFieldsValue()

    if (resData) {
      formData = { ...resData }
    } else {
      formData = {
        ...standardObj,
        ...unStandardObj,
      }
    }

    const newParamList = _.cloneDeep(paramList)
    const list = newParamList.filter(el => formData[el.argCode])
    list.map(item => {
      // 1. 转化值接收字段处理
      if (item.argType === 'CHOOSE') {
        item.values = formData[item.argCode]
          ? item.argValueJson.list
              .filter(el => formData[item.argCode].includes(el.id))
              ?.map(arg => ({ valueId: arg?.id, valueName: arg?.name }))
          : []
      } else {
        item.argValueJson = {
          strVal: formData[item.argCode]?.length ? formData[item.argCode] : '',
        }
      }
      return item
    })
    return list || []
  }

  // 缓存提交第二步数据
  const onSubmit = async () => {
    const formValidates = await Promise.all([formRef.validateFields(), unFormRef.validateFields()])
    if (!formValidates) {
      throw new Error('')
    }
    const isPackage = ['PRODUCT_PACKAGE', 'PRODUCT_DETAILS'].includes(step1Data.prodType)

    let skuRes: any = []
    // 这地方取消深拷贝，否则会导致第三步判断skuList一直改变，导致添加的数据消失
    const newData = { ...step2Data }

    if (!isPackage && newData.skuList?.length === 0) {
      if (step2Data.config?.[0]?.formItem?.length) {
        message.error('请添加sku')
        throw new Error('')
      } else {
        // 默认创建一条sku数据
        skuRes = await createSkuByArgs({
          spuName: step1Data.prodName,
          argList: [],
        })
        newData.skuList = [
          {
            ...(skuRes?.skuList?.[0] || {}),
          },
        ]
        newData.skuByArgs = skuRes?.skuList
      }
    }
    const specificationArgList = newData.config?.[0]?.formItem?.map((item: any) => ({
      id: item.id,
      argCode: item.argCode,
      argType: item.argType,
      argName: item.argName,
      values: formValidates?.[0]?.[item.argCode]
        ? formValidates?.[0]?.[item.argCode]?.map(item => ({ valueId: item }))
        : undefined,
    }))
    const argList = newData.notStandardConfig?.[0]?.formItem?.map((item: any) => ({
      id: item.id,
      argCode: item.argCode,
      argType: item.argType,
      argName: item.argName,
      values: formValidates?.[1]?.[item.argCode]
        ? formValidates?.[1]?.[item.argCode]?.map(item => ({ valueId: item }))
        : undefined,
    }))
    newData['specificationArgList'] = specificationArgList
    newData['argList'] = argList
    setStep2Data(newData)
  }

  // 处理弹窗表单
  const handleConfig = config => {
    const modalJsonList = _.cloneDeep(paramList)
    const newConfig = _.cloneDeep(config)
    const formValue = formRef.getFieldsValue()

    if (newConfig[0]?.formItem && newConfig[0]?.formItem.length) {
      newConfig[0].formItem = newConfig[0]?.formItem
        .map(item => {
          if (item.type === 'CHOOSE') {
            let option = []
            modalJsonList.forEach(el => {
              if (el.argCode === item.name) {
                option = el.argValueJson.list
              }
            })
            option = option.filter(el => {
              if (formValue[item.name]?.includes(el.id)) {
                return el
              }
            })
            // 再过滤只包含已选的选项
            return {
              label: item.label,
              name: item.name,
              required: item.required,
              spanCol: item.spanCol,
              type: item.type,
              children: (
                <>
                  {item.type === 'CHOOSE' && (
                    <Select
                      key={item.name}
                      mode="multiple"
                      defaultValue={formValue[item.name]}
                      onChange={e => {
                        const formUse = onCreateSkuFormRef()
                        formUse.setFieldsValue({
                          [item.name]: e,
                        })
                      }}
                      // style={{ width: '80%' }}
                      fieldNames={{ label: 'name', value: 'id' }}
                      options={option}
                    />
                  )}
                </>
              ),
            }
          }
        })
        .filter(item => item)

      return newConfig
    }
  }
  return (
    <Spin spinning={spinLoading}>
      <div style={{ width: '100%', height: '100%', display: 'flex' }}>
        <Row style={{ width: '100%', height: '100%' }}>
          {['PRODUCT_PACKAGE', 'PRODUCT_DETAILS'].includes(step1Data.prodType) && (
            <Col span={24} style={{ marginBottom: 10 }}>
              <SAlert type="info">
                由打包模板创建的产品该位置自动同步打包模板的规格参数。可以新添加非规格参数
              </SAlert>
            </Col>
          )}
          {!['PRODUCT_PACKAGE', 'PRODUCT_DETAILS', 'PRODUCT_GROUP'].includes(
            step1Data.prodType
          ) && (
            <Col span={24} style={{ marginBottom: 10 }}>
              <SAlert type="info">已进行SKU设置后，若修改规格，会影响SKU配置，请谨慎操作</SAlert>
            </Col>
          )}
          {['PRODUCT_GROUP'].includes(step1Data.prodType) && (
            <Col span={24} style={{ marginBottom: 10 }}>
              <SAlert type="info">组合产品只能添加描述性非规格参数</SAlert>
            </Col>
          )}
          <Col span={24}>
            <STitle title={<span>规格配置</span>} />
            <div style={{ display: 'flex', marginTop: 10 }}>
              {/* 规格参数 */}
              {!['PRODUCT_GROUP'].includes(step1Data.prodType) ? (
                <Col span={10}>
                  <div>
                    <Button
                      // style={{ width: 80 }}
                      type="primary"
                      onClick={() => clickToAdd('standard')}
                      disabled={
                        ['PRODUCT_PACKAGE', 'PRODUCT_DETAILS'].includes(step1Data.prodType) ||
                        step1Data.sourceType !== 'SELF'
                      }
                    >
                      添加参数
                    </Button>
                  </div>
                  <Form
                    style={{ marginTop: '10px' }}
                    form={formRef}
                    // httpOptionsFn={getOptions}
                    layout={'vertical'}
                    initialValues={{}}
                  >
                    {step2Data.config?.[0]?.formItem?.length
                      ? step2Data?.config?.[0]?.formItem.map(item => (
                          <>
                            {item.argType === 'CHOOSE' ? (
                              <div style={{ position: 'relative', display: 'flex', width: '100%' }}>
                                <Form.Item
                                  label={item.argName}
                                  name={item.argCode}
                                  style={{ width: '80%' }}
                                  rules={[
                                    {
                                      required: item.argType === 'CHOOSE' ? true : false,
                                      message: `${item.argName}不能为空`,
                                    },
                                  ]}
                                >
                                  <Select
                                    key={item.argCode}
                                    mode="multiple"
                                    onChange={e => {
                                      formRef.setFieldsValue({
                                        [item.argCode]: e,
                                      })
                                      const formValue = formRef.getFieldsValue()
                                      for (const key in formValue) {
                                        if (formValue[key] && formValue[key].length > 0) {
                                          setShowCreateFlag(true)
                                          break
                                        } else {
                                          setShowCreateFlag(true)
                                        }
                                      }
                                      deleteSkuData()
                                    }}
                                    placeholder="请选择"
                                    fieldNames={{ label: 'name', value: 'id' }}
                                    options={item.options?.argValueJson?.list || []}
                                    disabled={
                                      item.forBidDelete ||
                                      Boolean(id && step1Data.sourceType !== 'SELF')
                                    }
                                  />
                                </Form.Item>
                                {!item.forBidDelete && (
                                  <MinusCircleOutlined
                                    style={{ marginLeft: 8 }}
                                    className="dynamic-delete-button"
                                    onClick={() => {
                                      remove(item.argCode, 'standard')
                                    }}
                                  />
                                )}
                              </div>
                            ) : null}
                            {item.argType === 'INPUT' ? (
                              <div style={{ position: 'relative', display: 'flex', width: '100%' }}>
                                <Form.Item
                                  label={item.argName}
                                  name={item.argCode}
                                  style={{ width: '80%' }}
                                  rules={[
                                    {
                                      required: item.argType === 'CHOOSE' ? true : false,
                                      message: `${item.argName}不能为空`,
                                    },
                                  ]}
                                >
                                  <Input placeholder="值由用户输入" disabled={true} />
                                </Form.Item>
                                {!item.forBidDelete && (
                                  <MinusCircleOutlined
                                    style={{ marginLeft: 8 }}
                                    className="dynamic-delete-button"
                                    onClick={() => {
                                      remove(item.argCode, 'standard')
                                    }}
                                  />
                                )}
                              </div>
                            ) : null}
                          </>
                        ))
                      : null}
                  </Form>
                </Col>
              ) : null}
              <Col span={10}>
                {/* 非规格参数 */}
                <div>
                  <Button
                    style={{ width: 150 }}
                    type="primary"
                    onClick={() => clickToAdd('unStandard')}
                  >
                    添加非规格参数
                  </Button>
                </div>
                <Form
                  style={{ marginTop: '10px' }}
                  form={unFormRef}
                  // httpOptionsFn={getOptions}
                  layout={'vertical'}
                  initialValues={{}}
                >
                  {step2Data.notStandardConfig?.[0]?.formItem?.length
                    ? step2Data?.notStandardConfig?.[0]?.formItem.map(item => (
                        <>
                          {item.argType === 'CHOOSE' ? (
                            <div style={{ position: 'relative', display: 'flex', width: '100%' }}>
                              <Form.Item
                                label={item.argName}
                                name={item.argCode}
                                style={{ width: '80%' }}
                                rules={[
                                  {
                                    required: item.argType === 'CHOOSE' ? true : false,
                                    message: `${item.argName}不能为空`,
                                  },
                                ]}
                              >
                                <Select
                                  key={item.argCode}
                                  mode="multiple"
                                  placeholder="请选择"
                                  fieldNames={{ label: 'name', value: 'id' }}
                                  options={item.options?.argValueJson?.list || []}
                                  disabled={item.forBidDelete}
                                  onChange={e => {
                                    unFormRef.setFieldsValue({
                                      [item.argCode]: e,
                                    })
                                  }}
                                />
                              </Form.Item>
                              {!item.forBidDelete && (
                                <MinusCircleOutlined
                                  style={{ marginLeft: 8 }}
                                  className="dynamic-delete-button"
                                  onClick={() => {
                                    remove(item.argCode, 'unStandard')
                                  }}
                                />
                              )}
                            </div>
                          ) : null}
                          {item.argType === 'INPUT' ? (
                            <div style={{ position: 'relative', display: 'flex', width: '100%' }}>
                              <Form.Item
                                label={item.argName}
                                name={item.argCode}
                                style={{ width: '80%' }}
                                rules={[
                                  {
                                    required: item.argType === 'CHOOSE' ? true : false,
                                    message: `${item.argName}不能为空`,
                                  },
                                ]}
                              >
                                <Input placeholder="值由用户输入" disabled={true} />
                              </Form.Item>
                              {!item.forBidDelete && (
                                <MinusCircleOutlined
                                  style={{ marginLeft: 8 }}
                                  className="dynamic-delete-button"
                                  onClick={() => {
                                    remove(item.argCode, 'unStandard')
                                  }}
                                />
                              )}
                            </div>
                          ) : null}
                        </>
                      ))
                    : null}
                </Form>
              </Col>
            </div>
          </Col>
          {!['PRODUCT_PACKAGE', 'PRODUCT_DETAILS', 'PRODUCT_GROUP'].includes(step1Data.prodType) &&
            showCreateFlag && (
              <Col span={24}>
                <STitle title={'SKU配置'} />
                <Button
                  type="primary"
                  style={{ margin: '10px 0px' }}
                  onClick={() => {
                    openToCreate()
                  }}
                  disabled={Boolean(id && step1Data.sourceType !== 'SELF')}
                >
                  添加配置
                </Button>
                <SkuTable
                  data={step2Data.skuList}
                  columns={[{ title: 'SKU序号', dataIndex: 'id' }, ...step2Data.skuTableColumns]}
                ></SkuTable>
              </Col>
            )}
        </Row>
        {/* 添加参数 */}
        <FormModal
          open={openSpecsModal}
          paramList={filterParamList}
          type={chooseModalType}
          onCancel={() => setOpenSpecsModal(false)}
          onConfirm={onConfirm}
        ></FormModal>
        {/* 添加配置弹窗 */}
        <SDrawerOrModal
          mode="modal"
          title="添加配置"
          open={skuFormOpen}
          onCancel={() => setSkuFormOpen(false)}
          onOk={onModalSubmit}
          width={520}
        >
          {/* 规格的 */}
          {skuFormOpen && (
            <SGeneralForms
              ref={createSkuFormRef}
              // httpOptionsFn={getOptions}
              layout={'vertical'}
              configs={handleConfig(step2Data.config) || [{ formItem: [] }]}
            />
          )}
          {/* 非规格的 */}
          {/* <div style={{ marginTop: '-24px' }}>
            <SGeneralForms
              ref={notStandardFormRef}
              layout={'horizontal'}
              configs={step2Data.notStandardConfig}
            />
          </div> */}
        </SDrawerOrModal>
      </div>
    </Spin>
  )
})
